import { generatePath } from "react-router-dom";
import { formatNumberNDecimalPlaces } from "../../../utils/format";
import { getColor, colors } from "../../../utils/colors";
import { defaultCellValue, routeURLs } from "../../../utils/enums";
import { tViews } from "../../../utils/table";

export const getTableColumns = (navigate, siteId = -1, openTableSettings, reporting = false) => {
  const tableColumns = [
    {
      prop: "application",
      name: tViews('applicationTableViewName'),
      sortable: true,
      size: 200,
      cellTemplate: (createElement, { model, prop }) => {
        const linkElement = createElement(
          "div",
          {
            class: "table-link",
            onClick: () => {
              navigate(generatePath(routeURLs.app360, { appName: model[prop] }));
            }
          },
          model[prop]
        );
        return createElement("div", { class: "flex-items" }, linkElement);
      }
    },
    {
      prop: "vqoe_score",
      name: tViews('applicationTableViewQoE'),
      sortable: true,
      size: 100,
      cellProperties: ({ model, prop }) => {
        return { style: { color: getColor(model[prop], "qoe") } };
      }
    },
    {
      prop: "vqoe_change",
      name: tViews('applicationTableViewQoEChange'),
      sortable: true,
      size: 120,
      cellProperties: ({ model, prop }) => {
        return { style: { color: model[prop] < 0 ? colors.red45 : null } };
      }
    },
    {
      prop: "site_count",
      name: siteId === -1
        ? tViews('applicationTableViewSiteCount')
        : tViews('applicationTableViewCircuitCount'),
      sortable: true,
      size: 120
    },
    {
      prop: "application_class",
      name: tViews('applicationTableViewSiteTraffic'),
      size: 180,
      sortable: true,
    },
    {
      prop: "application_family_long_name",
      name: tViews('applicationTableViewAppFamily'),
      size: 220,
      sortable: true,
    },
    {
      prop: "display_usage",
      name: tViews('applicationTableViewUsage'),
      size: 120,
      sortable: true
    },
    {
      prop: "packet_loss",
      name: tViews('applicationTableViewLoss'),
      size: 140,
      sortable: true
    },
    {
      prop: "latency",
      name: tViews('applicationTableViewLatency'),
      size: 120,
      sortable: true
    },
    {
      prop: "jitter",
      name: tViews('applicationTableViewJitter'),
      size: 120,
      sortable: true
    },
    {
      prop: "anomaly_cnt",
      name: tViews('applicationTableAnomalyCount'),
      sortable: true,
      size: 130
    },
     {
      prop: "flow_records",
      name: tViews('applicationTableAnomalyTotalFlows'),
      sortable: true,
      size: 130
    },
    {
      prop: "flows_sla_not_met_percent",
      name: tViews('applicationTableFlowSlaNotMetPercentage'),
      sortable: true,
      size: 130
    },
    {
      prop: "flows_preferred_color_not_met_percent",
      name: tViews('applicationTableFlowPreferredColorNotMetPercentage'),
      sortable: true,
      size: 140
    }
  ];
  if (!reporting && typeof openTableSettings === "function") {
    tableColumns.push({
      prop: "actions",
      name: "Actions",
      hiddenText: "Actions",
      disableToggle: true,
      sortable: false,
      headerSlot: false,
      pin: "colPinEnd",
      size: 70,
      columnTemplate: (createElement) => {
        return createElement("hbr-icon-button", {
          name: "gear-six-outlined",
          class: "hbr-css__table-cell-align-center gear-icon",
          "data-testid": "setting-traffic-logs",
          onClick: (evt) => {
            evt.stopPropagation();
            openTableSettings();
          }
        });
      }
    });
  }
  for (const item of tableColumns) {
    if (item.prop !== "actions") {
      Object.assign(item, { id: item.prop, sortable: true });
    } else {
      Object.assign(item, { id: item.prop });
    }
  }
  return tableColumns;
};

const validateAndFormatNumber = (value, decimalPlaces = 1) => {
  if (Number.isFinite(value))
    return formatNumberNDecimalPlaces(value, decimalPlaces);
  return defaultCellValue;
};

export const setApplicationsData = data => {
  for (const item of data) {
    item.checked = false;
    if (item.vqoe_status === "unknown") {
      item.vqoe_score = defaultCellValue;
      item.vqoe_change = defaultCellValue;
      item.packet_loss = defaultCellValue;
      item.latency = defaultCellValue;
      item.jitter = defaultCellValue;
    }
    else {
      item.vqoe_score = validateAndFormatNumber(item.vqoe_score);
      item.vqoe_change = validateAndFormatNumber(item.vqoe_change);
      if (item.vqoe_change > 0) item.vqoe_change = `+${item.vqoe_change}`;
      item.packet_loss = validateAndFormatNumber(item.packet_loss);
      item.latency = validateAndFormatNumber(item.latency);
      item.jitter = validateAndFormatNumber(item.jitter);
    }
  }
  return data;
};
